import { Banner } from '@/components/Banner/Banner';
import { COLORS } from '@/styles/colors';
import { useNavigate } from 'react-router';
import FlameIcon from '@/bundle/shared/components/banner/images/FlameIcon.svg?react';
import { CompletePaymentBlock } from '../../styles';
import BannerArrowIcon from '@/bundle/shared/components/banner/images/BannerArrowIcon.svg?react';
import { getMasterAdminBillingPath } from '@/bundle/_MasterAdmin/_BillingPage/path/path';
import { useUser } from '@/context/userContext';

export const SubscriptionCancelledBanner = () => {
  const navigate = useNavigate();
  const { isMasterAdminRole } = useUser();

  return (
    <Banner background={COLORS.grey[200]} icon={<FlameIcon />}>
      Your account is in <b>view-only mode</b> due to a cancelled subscription. Please{' '}
      {isMasterAdminRole ? (
        <CompletePaymentBlock onClick={() => navigate(getMasterAdminBillingPath())}>
          reactivate your subscription
          <BannerArrowIcon />
        </CompletePaymentBlock>
      ) : (
        <>
          <b>contact the Master Admin</b> of your organization.
        </>
      )}
    </Banner>
  );
};
